export default "__VITE_ASSET__Bw9kvP4V__"